module.exports = __webpack_public_path__ + "img/icon_ai_news@2x.9e6ed49b.png";